import { EventType, SourcePages, Features } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';

const advancedOptions: Record<string, string> = {
  hideOnlineListings: 'hide_online_listings',
  hideListingsNoImages: 'hide_listings_no_images',
};

export default function AdvancedTapEvent(label: string, sourcePage: SourcePages): EventData {
  return {
    event_type: EventType.engagement,
    source_page: sourcePage === SourcePages.Srp ? SourcePages.SrpFilter : SourcePages.SeoSrpFilter,
    feature: Features.advanced,
    engagement_type: `${advancedOptions[label]}_tap`,
  };
}
